<div class="delete-account-container">
	<h1 mat-dialog-title class="mb-3">{{ translations['n247'] }}</h1>

	<div mat-dialog-content>
		<p class="mb-3">{{ translations[description] }}</p>

		<ng-container [ngSwitch]="authType">
			<ng-template *ngSwitchCase="authTypeEnum.DELETE_ACCOUNT_HAS_ADS" [ngTemplateOutlet]="deleteAccountHasAdsContent"></ng-template>
			<ng-template *ngSwitchCase="authTypeEnum.DELETE_ACCOUNT" [ngTemplateOutlet]="deleteAccountContent"></ng-template>
		</ng-container>
	</div>

	<div mat-dialog-actions class="justify-content-end gap-3">
		<app-button *ngIf="btnSecondaryLabel" [btnType]="buttonType.BASIC" [label]="btnSecondaryLabel" (clicked)="onBtnSecondaryClick()"></app-button>
		<app-button [isLoading]="isLoading" [label]="btnPrimaryLabel" (clicked)="onBtnPrimaryClick()"></app-button>
	</div>

	<button hidden cdkFocusInitial></button>
</div>

<ng-template #deleteAccountHasAdsContent>
	<div class="attention attention--info mb-3">
		<span>
			{{ translations['n580'] }}
			<span class="fw-bold">{{ user.placedAds }}</span>
		</span>
	</div>

	<p class="mb-3">
		{{ translations['n583'] }}
		<span class="fw-bold">{{ translations['n7'] }}</span>
		{{ translations['n579'] }}
	</p>
</ng-template>

<ng-template #deleteAccountContent>
	<div class="attention attention--warning mb-3">
		<mat-icon class="mr-2" svgIcon="exclamation-warning"></mat-icon>
		<div class="d-inline-block">
			<span class="fw-500 mr-1">{{ translations['n577'] }}</span>
			<span>{{ translations['n578'] }}</span>
		</div>
	</div>
</ng-template>
